export default __webpack_public_path__ + "static/media/SFamilles.60a20fb7.xlsx";